
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import getWindowScroll from './getWindowScroll.js';
import getWindow from './getWindow.js';
import { isHTMLElement } from './instanceOf.js';
import getHTMLElementScroll from './getHTMLElementScroll.js';

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

export { getNodeScroll as default };
//# sourceMappingURL=getNodeScroll.js.map
